import React from "react"

type InputErrorsProps = {
  errors: string[]
  name: string
}

export const InputErrors = (props: InputErrorsProps) => {
  const { errors, name } = props
  return (
    <div className="text-xs mt-1 text-stears_danger text-left">
      {errors.map((err, index) => (
        <p
          id={name + "-error-" + index}
          key={err}
          className={index ? "mt-0.5" : ""}
        >
          {err}
        </p>
      ))}
    </div>
  )
}

export default InputErrors
